import { MenuItemActivatedType } from "../types";

export const NAME = "customActions";

/**
 * Typy položek menu, pro které jsou podporované custom akce.
 */
export const supportedMenuItemTypes = [
    MenuItemActivatedType.form,
    MenuItemActivatedType.formFolder,
    MenuItemActivatedType.profile,
    MenuItemActivatedType.panelItemForm,
    MenuItemActivatedType.panelItemFormFolder,
    MenuItemActivatedType.notificationGroup,
    MenuItemActivatedType.logoButton,
    MenuItemActivatedType.panelItemCombinedItemForm,
    MenuItemActivatedType.panelItemCombinedItemFolder,
];

/**
 * Typy položek, které pro zpracování využívají data ve formátu formulářové položky.
 */
export const formCompatibleItems = [
    MenuItemActivatedType.form,
    MenuItemActivatedType.formFolder,
    MenuItemActivatedType.profile,
    MenuItemActivatedType.panelItemForm,
    MenuItemActivatedType.panelItemFormFolder,
    MenuItemActivatedType.panelItemCombinedItemForm,
    MenuItemActivatedType.panelItemCombinedItemFolder,
];
